import React, { Component } from 'react'
import { getImpUsers, handleUnlockUser, getUnlockedUsers, getAppUsers } from '../../../firebase/database/handleUserMgm'
import List from '../../../Container/Lists/List'
//import _ from 'lodash'
import Loading from '../../../Container/Loading/Loading'
//import ListItemDetails from './ListItemDetails'
import {connect} from 'react-redux'
import InputFilter from '../../../Container/Filter/InputFilter'
import DefaultPage from '../../../Container/Layout/DefaultPage'
import PopUp from '../../../Container/PopUps/PopUp'
import Typography from '@material-ui/core/Typography'
import arraySort from 'array-sort'

class UserMgm extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          filteredImpUsers: null,
          activeView: 'list',
          selectedUser: null,
          loading: true,
          hideListItem: null,
          popUp: {
              active: false,
              title: null,
              content: null,
              type: 'info',
              buttonConfig: '',
          },
          unlockConfirmed: false,
        };
    }

    async componentDidMount () {
        if(this.props.impUsers===null)     
        await getUnlockedUsers()   
        await getImpUsers()
        this.setState({loading: false})
    }

    resetPopUp = () => {
        this.setState({
            unlockConfirmed: false,
            popUp: {
            active: false,
            title: null,
            content: null,
            type: 'info',
        },})

    }


    toggleView = (selectedId) => {
        const { activeView } = this.state
     
        if(activeView==='details') {
            this.setState({
                loading: true,
                activeView: 'list',
                selectedUser: null
            })
        } else {
            this.setState({
                selectedUser: this.props.impUsers[selectedId],
                activeView: 'details',
                loading: true
            })
        }
        setTimeout(()=>this.setState({loading: false}), 3000);
       
    }

    unlockUser = async (item) => {
        //console.log(id)
        const id = item.extId
        const userArr = this.state.filteredImpUsers || this.props.impUsers
        const getArrIndex = (element) => {
            return element.extId === id
        }
        const arrIndex = userArr.findIndex(getArrIndex)
        //console.log('arrIndex', arrIndex)
        const unlockedUser = userArr[arrIndex]
        const { name, vorname, ort, email } = unlockedUser

        const checkDuplicates = (compProp, compValue, values) => {
            return values.filter(value =>{
                //console.log(value[compProp])
                return value[compProp] === compValue
            })
        }
        if(email==='' || email==='Nicht vorhanden')
           return this.setState({popUp: {
                active: true,
                type: 'warning',
                title: 'Keine Email Adresse',
                content: <span>Das Mitglied <strong>{vorname} {name}</strong> hat keine Email Adresse. Ohne Email Adresse ist keine Freischaltung möglich</span>,
                btnConfig: 'popUpNoEmail'
            }})

        const users = await getAppUsers()
        const duplicates = await checkDuplicates('email', email, users)
        
        const duplicatesFound = duplicates.length>0
        if (duplicatesFound) 
        return this.setState({
            popUp: {
                active: true,
                type: 'warning',
                title: 'Benutzer Vorhanden',
                content: <span>
                            Es existiert bereits ein Benutzer: 
                            <strong>{duplicates[0].vorname} {duplicates[0].name}
                            </strong> mit der Email Adresse <strong> {duplicates[0].email}
                            </strong><br/><br/>
                            <Typography variant='body1' color='secondary' >
                                Jeder Benutzer benötigt eine eindeutige Email Adresse für die Freischaltung
                            </Typography>
                        </span>,
                btnConfig: 'popUpEmailExists'   
            }
            })

        const confirmed = window.confirm('Das Mitglied ' + name + ' ' + vorname + ' in ' + ort + ' erhält die Zugangsdaten per Email und wird für die App freigeschalten')
        if(confirmed===false)return null
        this.setState({hideListItem: item.extId})
        handleUnlockUser(unlockedUser)
    }

    buttonConfig = {
        userItem: [
            {
                title: 'Freischalten', 
                onClick:this.unlockUser
            }, 
        ],
        popUpEmailExists: [
            {
                title: 'OK',
                color: 'primary',
                variant: '',
                onClick:()=>this.setState({popUp:{ active: false, title: null, content: null, type: null}}),
            }
        ],
        popUpNoEmail: [
            {
                title: 'OK',
                color: 'primary',
                variant: '',
                onClick:()=>this.setState({popUp:{ active: false, title: null, content: null, type: null}}),
            },
        ],
        confiremUnlockUser: [
            {
                title: 'Freischalten',
                color: 'primary',
                onClick: ()=>this.setState({unlockConfirmed: true, popUp: {active: false} })

            }
        ]
    }


   
    render () {
        
        if(this.props.loading===true || this.props.impUsers===null) return <Loading text='Daten werden geladen....' />
       return (
           <DefaultPage headline={{headlineText: 'Mitglieder Freischalten'}}>
                <InputFilter 
                    initList={this.props.impUsers}
                    callback={(filteredList)=>this.setState({filteredImpUsers: filteredList})}
                    counter={this.state.filteredImpUsers!==null ? this.state.filteredImpUsers.length : null}
                    filterProps={['name', 'ort']}
                    filterActive={this.state.filteredImpUsers!==null}
                    />
                

                <List 
                    items={this.state.filteredImpUsers===null ? arraySort(this.props.impUsers, 'name') : this.state.filteredImpUsers}
                    itemHeight={40}
                    headerProps={['Name', 'Ort', 'Email', 'Typ', 'Freischalten']}
                    renderProps={['name', 'ort', 'email', 'role']}
                    buttons= {this.buttonConfig.userItem}
                    listItemToHide={this.state.hideListItem}
                    />
                {this.state.popUp.active 
                    ? 
                        <PopUp 
                            type={this.state.popUp.type}
                            title={this.state.popUp.title}
                            content={this.state.popUp.content}
                            buttons={this.buttonConfig[this.state.popUp.btnConfig]}
                        />
                    : null   
                    }

           
           </DefaultPage>
          
       )
    }
}

const mapStateToProps = (state) => ({
    impUsers: state.adminUserMgm.impUsers,
    unlockedUsers: state.adminUserMgm.unlockedUsers
})

export default connect(mapStateToProps)(UserMgm)


// WEBPACK FOOTER //
// ./src/Components/Admin/UserMgm/UserMgm.js